import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Row, Col, Button } from 'antd'
import imgBalloons from 'assets/image/balloons@3x.png'
import imgTada from 'assets/image/tada@3x.png'
import './style.css'

class NameForm extends Component {
  state = {
    username: '',
  }

  handleButtonClick = () => {
    const { username } = this.state
    if (!username) {
      alert('请别忘记填写你的姓名')
      return
    }

    window.localStorage.setItem('sspai_username', username)
    this.props.history.push('/result')
  }

  onChangeInput = e => {
    this.setState({ username: e.target.value })
  }

  render() {
    return (
      <Row>
        <Col>
          <Row style={{ width: 250, margin: '120px auto 0' }}>
            <Col>
              <Row style={{ textAlign: 'center' }}>
                <Col>
                  <img style={{ width: 150 }} src={window.sspaiStaticRoot + imgBalloons} alt='balloons' />
                </Col>
              </Row>

              <Row style={{ textAlign: 'center', marginTop: 40 }}>
                <Col>
                  <input
                    id='name-form-input'
                    type='text'
                    style={{
                      padding: '0 12px',
                      height: 48,
                      width: '100%',
                      borderRadius: 100,
                      backgroundColor: 'rgba(39, 41, 54, 0.65)',
                      border: 'none',
                    }}
                    placeholder='你的姓名'
                    onChange={this.onChangeInput}
                  />
                </Col>
              </Row>

              <Row style={{ textAlign: 'center', marginTop: 100 }}>
                <Col>
                  <Button
                    style={{ backgroundColor: '#272936', borderRadius: 100, color: '#eb5757', height: 50, width: 140 }}
                    type='primary'
                    size='large'
                    onClick={this.handleButtonClick}
                  >
                    <img style={{ width: 20, marginTop: -5, marginRight: 8 }} src={imgTada} alt='tada' /> 查看结果
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default withRouter(NameForm)
